// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import DataItemListResourceViewModel from '../../../../viewModel/resource/DataItemListResourceViewModel';
import DataItemListResourceDTO from '../../dto/resource/DataItemListResourceDTO';

export default abstract class DataItemListResourceModel extends BaseModel<DataItemListResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }
  /**
  */
  get subTitle() { return this.dto.subTitle; }
  set subTitle(value) { this.dto.subTitle = value; }
  /**
  */
  get comment() { return this.dto.comment; }
  set comment(value) { this.dto.comment = value; }
  /**
  */
  get pictureDocumentExternalId() { return this.dto.pictureDocumentExternalId; }
  set pictureDocumentExternalId(value) { this.dto.pictureDocumentExternalId = value; }
  /**
  * @type {int64}
  */
  get statusId() { return this.dto.statusId; }
  set statusId(value) { this.dto.statusId = value; }
  /**
  */
  get statusCaption() { return this.dto.statusCaption; }
  set statusCaption(value) { this.dto.statusCaption = value; }
  /**
  * @type {int64}
  */
  get categoryId() { return this.dto.categoryId; }
  set categoryId(value) { this.dto.categoryId = value; }
  /**
  */
  get categoryCaption() { return this.dto.categoryCaption; }
  set categoryCaption(value) { this.dto.categoryCaption = value; }
  /**
  * @type {date-time}
  */
  get validFrom() { return this.dto.validFrom; }
  set validFrom(value) { this.dto.validFrom = value; }
  /**
  * @type {date-time}
  */
  get validUntil() { return this.dto.validUntil; }
  set validUntil(value) { this.dto.validUntil = value; }
  /**
  * @type {int64}
  */
  get contentTypeId() { return this.dto.contentTypeId; }
  set contentTypeId(value) { this.dto.contentTypeId = value; }
  /**
  */
  get contentTypeCaption() { return this.dto.contentTypeCaption; }
  set contentTypeCaption(value) { this.dto.contentTypeCaption = value; }
  /**
  */
  get searchTerms() { return this.dto.searchTerms; }
  set searchTerms(value) { this.dto.searchTerms = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.title = qs.title;
    this.dto.subTitle = qs.subtitle;
    this.dto.comment = qs.comment;
    this.dto.pictureDocumentExternalId = qs.picturedocumentexternalid;
    value = Number.parseFloat(qs.statusid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.statusId = value;
    this.dto.statusCaption = qs.statuscaption;
    value = Number.parseFloat(qs.categoryid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.categoryId = value;
    this.dto.categoryCaption = qs.categorycaption;
    this.dto.validFrom = qs.validfrom;
    this.dto.validUntil = qs.validuntil;
    value = Number.parseFloat(qs.contenttypeid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.contentTypeId = value;
    this.dto.contentTypeCaption = qs.contenttypecaption;
    this.dto.searchTerms = qs.searchterms;
  }
}
